<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal(false)">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-50" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="inline-block w-full max-w-screen-sm px-6 py-10 m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded flex flex-col justify-between skip-modal"
            >
              <div class="flex pb-5">
                <div class="flex items-center mr-2">
                  <ExclamationStopIcon :classes="'w-8 h-8'" />
                </div>
                <div class="flex items-center">
                  <h5 class="text-brand-red text-xl">
                    Warning: Skipping verification may impact your approval
                  </h5>
                </div>
              </div>

              <p class="py-1 text-sm">
                Verifying income and employment are an important aspect of the decision making
                process. Please select your reason for skipping down below.
              </p>
              <div class="flex flex-col py-5">
                <p class="">
                  Please provide a reason for skipping <span class="text-brand-red">*</span>
                </p>
                <div class="flex items-center py-2">
                  <DropDown
                    :options="skipReasonOptions"
                    @select="updateReason"
                    placeholder="Select reason"
                    dropDownSize="h-28"
                  />
                </div>

                <template v-if="reason === 'other'">
                  <p class="pt-2">Reason/Details</p>
                  <SingleLineInput
                    ref="input"
                    label="Other reason"
                    placeholder="Other reason"
                    :value="otherDetail"
                    type="text"
                    @input="otherDetail = $event.target.value"
                  />
                </template>

                <template v-if="errorMessage">
                  <p class="py-1 text-brand-red">{{ errorMessage }}</p>
                </template>
              </div>

              <div class="flex flex-row justify-end pt-10">
                <div class="flex items-center w-1/3">
                  <PrimaryButton
                    :classes="'bg-brand-red border-brand-red hover:bg-brand-red'"
                    :is-loading="isApplicationLoading"
                    :disabled="!reason"
                    @click="skip"
                    >Skip verification</PrimaryButton
                  >
                </div>
                <div class="ml-10 flex items-center">
                  <PrimaryButton @click="closeModal(false)"
                    >Continue with verification</PrimaryButton
                  >
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"
import { APPLICATION_SKIP_INCOME_VERIFICATION } from "@/store/types"

import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

// import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay
  },
  computed: {
    ...mapGetters(["getCurrentApplication", "isApplicationLoading"])
  },
  data() {
    return {
      skipReasonOptions: [
        {
          label: "No bank account",
          value: "no_bank_account"
        },
        {
          label: "Finicity does not have my bank institution as an option",
          value: "no_institution"
        },
        {
          label: "Connecting with Finicity failed",
          value: "connect_fail"
        },
        {
          label: "No income to verify",
          value: "no_income"
        },
        {
          label: "Other",
          value: "other"
        }
      ],
      reason: "",
      otherDetail: "",
      errorMessage: ""
    }
  },
  methods: {
    async skip() {
      if (!this.reason || (this.reason === "other" && !this.otherDetail)) {
        this.errorMessage = "Reason is required."
        return
      }

      const { reason, otherDetail } = this
      await this.$store.dispatch(APPLICATION_SKIP_INCOME_VERIFICATION, {
        id: this.getCurrentApplication.id,
        reason,
        otherDetail
      })
      this.closeModal(true)
    },
    closeModal(next) {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.$emit("close", next)
    },
    updateReason(val) {
      this.reason = val.value
    }
  }
}
</script>
